export default function authenticated ({ next, store, nextVue }){
    if (! store.state.auth.user) {
        return nextVue({
            path: '/',
        })
    }

    return next()
}